import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ClientsList = () => {
  const navigate = useNavigate();

  const clients = [
    {
      id: 'camargo',
      name: 'Camargo',
      meetings: 5
    },
    {
      id: 'apolar',
      name: 'Apolar',
      meetings: 2
    },
    {
      id: 'lopes',
      name: 'Lopes',
      meetings: 1
    },
    {
      id: 'paradise',
      name: 'Paradise',
      meetings: 1
    }
  ];

  return (
    <Container>
      <Header>
        <Title>Clientes</Title>
        <Subtitle>Gerenciamento de clientes e reuniões</Subtitle>
      </Header>

      <ClientsGrid>
        {clients.map(client => (
          <ClientCard 
            key={client.id}
            onClick={() => navigate(`/clientes/${client.id}`)}
          >
            <ClientIcon>{client.name.charAt(0)}</ClientIcon>
            <ClientInfo>
              <ClientName>{client.name}</ClientName>
              <ClientMeetings>{client.meetings} {client.meetings === 1 ? 'reunião' : 'reuniões'}</ClientMeetings>
            </ClientInfo>
            <ArrowIcon>→</ArrowIcon>
          </ClientCard>
        ))}
      </ClientsGrid>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  padding: 4rem 2rem;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-family: 'Orbitron', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  background: linear-gradient(135deg, #64B6FF 0%, #34CFEB 50%, #00FFFF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  letter-spacing: 4px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  color: rgba(100, 182, 255, 0.8);
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ClientsGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ClientCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(100, 182, 255, 0.3);
  border-radius: 12px;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(100, 182, 255, 0.1);
    border-color: rgba(100, 182, 255, 0.6);
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(100, 182, 255, 0.2);
  }
`;

const ClientIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #64B6FF 0%, #34CFEB 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: #0a0a0a;
  flex-shrink: 0;
`;

const ClientInfo = styled.div`
  flex: 1;
`;

const ClientName = styled.h3`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 0.5rem;
`;

const ClientMeetings = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  color: rgba(100, 182, 255, 0.7);
`;

const ArrowIcon = styled.div`
  font-size: 1.5rem;
  color: rgba(100, 182, 255, 0.6);
  transition: transform 0.3s ease;

  ${ClientCard}:hover & {
    transform: translateX(4px);
    color: rgba(100, 182, 255, 1);
  }
`;

export default ClientsList;
